(() => {
  const form = document.querySelector('.jamila-contact-form');
  if (!form) return;

  const feedback = form.querySelector('[data-jamila-contact-feedback]');
  if (feedback && feedback.textContent.trim()) {
    feedback.focus({ preventScroll: false });
  }

  form.addEventListener('submit', () => {
    if (!form.checkValidity()) return;
    const button = form.querySelector('[type="submit"]');
    if (!button) return;

    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    const label = button.querySelector('span');
    if (label) label.textContent = 'Sending…';
  });
})();
